import { IconCollection } from '@components/icons/iconCollection';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

/**
 * Возвращает IconProp для файла на основе MIME-типа
 * Единая логика выбора иконки для всех компонентов
 */
export const getIconByMimeType = (mimeType: string): IconProp => {
  if (!mimeType) {
    return IconCollection.fileThin;
  }

  /*
   * У `documentKind` фолбэка нет и не должно быть: `split` всегда возвращает
   * массив хотя бы из одного элемента, значит `[0]` — строка, и стоявшее здесь
   * `|| ''` подставляло `''` вместо `''`, то есть не делало ничего. У
   * `mimeSubtype` фолбэк настоящий: `mimeType` приходит из `File.type`, который
   * задаёт браузер по расширению, и для неизвестного расширения это либо `''`
   * (отсечено проверкой выше), либо строка без `/` — тогда `[1]` отсутствует.
   */
  const documentKind = mimeType.split('/', 1)[0];
  const mimeSubtype = mimeType.split('/', 2)[1] || '';

  switch (documentKind) {
    case 'image': {
      return IconCollection.imageThin;
    }
    case 'video': {
      return IconCollection.videoThin;
    }
    case 'audio': {
      return IconCollection.audioThin;
    }
    case 'text': {
      return mimeSubtype === 'csv'
        ? IconCollection.csvThin
        : IconCollection.textThin;
    }
    case 'application': {
      if (mimeSubtype === 'pdf') {
        return IconCollection.pdfThin;
      }
      if (
        mimeSubtype === 'vnd.ms-powerpoint' ||
        mimeSubtype ===
          'vnd.openxmlformats-officedocument.presentationml.presentation'
      ) {
        return IconCollection.pptThin;
      }
      if (
        mimeSubtype === 'msword' ||
        mimeSubtype ===
          'vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        return IconCollection.wordThin;
      }
      if (
        mimeSubtype === 'vnd.ms-excel' ||
        mimeSubtype === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        return IconCollection.excelThin;
      }
      return IconCollection.fileThin;
    }
    default: {
      return IconCollection.fileThin;
    }
  }
};
